var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-root"},[_c('div',{ref:"collapsedHeader",staticClass:"collapsed-header"},[_vm._t("small")],2),_c('div',{ref:"expandedHeader",staticClass:"expanded-header"},[_vm._t("large")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }